var dropOverlay = 'fx_2d2fb1e5_1y1q8st0';

export { dropOverlay };
//# sourceMappingURL=drop-overlay.vanilla.mjs.map
